import { IoArrowBack } from "react-icons/io5";
import './BookingAppointmentCss/ConfirmationSection.css';

import qrCode from '../../Assets/doctor&patient.png';
import { FaPhone } from "react-icons/fa6";
import { SiTicktick } from "react-icons/si";
export default function ConfirmationSection({ onNext, onBack } = {}) {
    return (
        <>
            <div className="step1-container">

                <div className="confirm-wrapper">
                    <div className="confirm-left">
                        <div className="confirm-header">
                            <span className="confirm-status-icon"><SiTicktick color="green" size={35} /></span>
                            <h2 className="confirm-status-text">Booking Confirmed</h2>
                        </div>

                        <div className="confirm-doctor">
                            {/* <img src={doctorImg} alt="Doctor" className="confirm-doctor-img" /> */}
                            <div>
                                <p className="confirm-message">
                                    Your Booking has been Confirmed with <strong>Dr. A K Jain</strong>
                                </p>
                                <p className="confirm-subtext">be on time before <strong>15 Mins</strong> from the appointment Time</p>
                            </div>
                        </div>

                        <div className="confirm-info">
                            <div className="confirm-info-header">
                                <h3>Booking Info</h3>
                                <button className="confirm-reschedule-btn rbdButton"><span className="btn-text">Reschedule</span> </button>
                            </div>

                            <div className="confirm-info-details">
                                <div>
                                    <p><strong>Service</strong><br />Cardiology (30 Mins)</p>
                                    <p><strong>Date & Time</strong><br />10:00 - 11:00 AM, 15 Oct 2025</p>
                                    <p><strong>Clinic Name & Location</strong><br />Wellness Path <a href="/">View Location</a></p>
                                </div>
                                <div>
                                    <p><strong>Additional Service</strong><br />Echocardiograms</p>
                                    <p><strong>Appointment Type</strong><br />Clinic</p>
                                </div>
                            </div>
                        </div>

                        <div className="confirm-assist-box">

                            <div className="confirm-assist-box-secont">
                                <h4>Need Our Assistance</h4>
                                <button className="confirm-call-btn rbdButton"><span className="btn-text" style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center"
                                }}><FaPhone /> Call Us</span></button>
                            </div>
                            <p style={{margin:"0", width:"70%"}}>Call us in case you face any issue on Booking / Cancellation</p>
                            
                        </div>
                    </div>

                    <div className="confirm-right">
                        <div className="confirm-booking-id">
                            <p>Booking Number</p>
                            <h3 className="confirm-booking-code">DCRA12565</h3>
                        </div>

                        <img src={qrCode} alt="QR Code" className="confirm-qr-code" />
                        <p className="confirm-qr-text">Scan this QR Code to Download the details of Appointment</p>

                        <button className="confirm-calendar-btn rbdButton" ><span className="btn-text">Add To Calendar</span></button>
                        <button className="confirm-newbooking-btn rbdButton"><span className="btn-text">Start New Booking</span></button>
                    </div>
                </div>



                <hr style={{
                    marginBottom: "1rem",
                    marginTop: "1rem",
                    border: 'none',
                    borderTop: '1px solid #e0e0e0',
                    width: '100%',
                    margin: "auto"
                }} />

                {/* Footer */}
                <div className="step1-footer-buttons">
                    <button className="step1-back-btn rbdButton  reset-Btn reportBtn" onClick={onBack}>
                        <span className='btn-text'><IoArrowBack className="step1-back-icon " /> Back</span>
                    </button>
                </div>
            </div>
        </>
    )
}